export default class Vote {
  id?: number;
  stars_number?: number;
  comment?: string;
  programas_id?: number;
  owner_id?: number;
}
